export default "__VITE_ASSET__Cu_oUO84__"